import Vue from "vue";
import VueRouter from "vue-router";
// import store from "@/store";
// layouts
import Blanks from "@/layouts/BlankPage.vue";
import Cms from "@/layouts/CmsPage.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Index",
    redirect: () => {
      return "login";
    },
  },
  {
    path: "*",
    name: "*",
    component: () => import("@/views/Notfound.vue"),
  },
  {
    path: "/",
    component: Blanks,
    meta: { requiresAuth: false },
    children: [
      {
        path: "login",
        name: "Login",
        component: () => import("@/views/pages/Auth/Login.vue"),
      },
      {
        path: "register",
        name: "Register",
        component: () => import("@/views/pages/Auth/RegisterLengkap.vue"),
      },
      {
        path: "Forgot-password",
        name: "ForgotPassword",
        component: () => import("@/views/pages/Auth/ForgotPassword.vue"),
      },
      {
        path: "Register-Success",
        name: "RegisterSuccess",
        component: () => import("@/views/pages/Auth/RegisterSuccess.vue"),
      },
    ],
  },
  {
    path: "/",
    component: Cms,
    meta: { requiresAuth: true },
    children: [
      {
        path: "Dashboard",
        name: "DashboardPage",
        component: () => import("@/views/pages/Cms/HomeView.vue"),
      },
      {
        path: "Profile",
        name: "ProfilePage",
        component: () => import("@/views/pages/Cms/ProfileView.vue"),
      },
      {
        path: "Lengkapi-Data",
        name: "LengkapiData",
        component: () =>
          import("@/views/pages/Cms/students/register/Lengkapi.vue"),
      },
      {
        path: "About",
        name: "About",
        component: () => import("@/views/pages/Cms/Settings.vue"),
      },
      {
        path: "Program",
        name: "Program",
        component: () =>
          import("@/views/pages/Cms/settings/Program/paginate.vue"),
      },
      {
        path: "Audio",
        name: "Audio",
        component: () =>
          import("@/views/pages/Cms/settings/Audio/paginate.vue"),
      },
      {
        path: "Gallery",
        name: "Gallery",
        component: () =>
          import("@/views/pages/Cms/settings/Galleries/paginate.vue"),
      },
      {
        path: "Kegiatan",
        name: "Kegiatan",
        component: () =>
          import("@/views/pages/Cms/settings/Kegiatan/paginate.vue"),
      },
      {
        path: "Kalender-Akademik",
        name: "Kalender-Akademik",
        component: () =>
          import("@/views/pages/Cms/students/KalenderAkademik.vue"),
      },
      {
        path: "Absensi-Santri",
        name: "Absensi-Santri",
        component: () =>
          import("@/views/pages/Cms/attendances/students/paginate.vue"),
      },
      {
        path: "Absensi-Guru",
        name: "Absensi-Guru",
        component: () =>
          import("@/views/pages/Cms/attendances/teachers/paginate.vue"),
      },
      {
        path: "Kehadiran",
        name: "Kehadiran",
        component: () => import("@/views/pages/Cms/reports/Kehadiran.vue"),
      },
      {
        path: "Perkembangan-Diri",
        name: "Perkembangan-Diri",
        component: () =>
          import("@/views/pages/Cms/reports/PerkembanganDiri.vue"),
      },
      {
        path: "Pembayaran-Infaq",
        name: "Pembayaran-Infaq",
        component: () =>
          import("@/views/pages/Cms/reports/PembayaranInfaq.vue"),
      },
    ],
  },
  {
    path: "/Administrasi",
    component: Cms,
    meta: { requiresAuth: true },
    children: [
      {
        path: "User-Management",
        name: "Administrasi-User-Management",
        component: () =>
          import("@/views/pages/Cms/backoffice/users/paginate.vue"),
      },
      {
        path: "Absensi-Santri",
        name: "Administrasi-Absensi-Santri",
        component: () =>
          import("@/views/pages/Cms/attendances/students/paginate.vue"),
      },
      {
        path: "Absensi-Guru",
        name: "Administrasi-Absensi-Guru",
        component: () =>
          import("@/views/pages/Cms/attendances/teachers/backoffice.vue"),
      },
      // {
      //   path: "Absensi-Guru",
      //   name: "Administrasi-Absensi-Guru",
      //   component: () =>
      //     import(
      //       "@/views/pages/Cms/backoffice/attendances/teachers/paginate.vue"
      //     ),
      // },
      {
        path: "Kalender-Akademik",
        name: "Administrasi-Kalender-Akademik",
        component: () => import("@/views/pages/Cms/kalenderAkademik/Index.vue"),
      },
    ],
  },
  {
    path: "/Master-Data",
    component: Cms,
    meta: { requiresAuth: true },
    children: [
      {
        path: "Admin",
        name: "Admin",
        component: () => import("@/views/pages/Cms/users/admin/paginate.vue"),
      },
      {
        path: "Guru",
        name: "Guru",
        component: () => import("@/views/pages/Cms/users/guru/paginate.vue"),
      },
      {
        path: "Operator",
        name: "Operator",
        component: () => import("@/views/pages/Cms/users/staff/paginate.vue"),
      },
      {
        path: "Santri",
        name: "Santri",
        component: () =>
          import("@/views/pages/Cms/students/siswa/paginate.vue"),
      },
      {
        path: "Program",
        name: "Programs",
        component: () => import("@/views/pages/Cms/programs/paginate.vue"),
      },
      {
        path: "Kelas",
        name: "Kelas",
        component: () =>
          import("@/views/pages/Cms/backoffice/classes/paginate.vue"),
      },
      {
        path: "Mata-Pelajaran",
        name: "Mata-Pelajaran",
        component: () =>
          import("@/views/pages/Cms/backoffice/subjects/paginate.vue"),
      },
      {
        path: "Jadwal-Pelajaran",
        name: "Jadwal-Pelajaran",
        component: () =>
          import("@/views/pages/Cms/backoffice/schedule/paginate.vue"),
      },

      {
        path: "Silabus",
        name: "Silabus",
        component: () => import("@/views/pages/Cms/silabus/paginate.vue"),
      },
      {
        path: "Jenis-Iuran",
        name: "Jenis-Iuran",
        component: () => import("@/views/pages/Cms/JenisIuran/paginate.vue"),
      },
      {
        path: "Rekening-Bank",
        name: "RekeningBank",
        component: () => import("@/views/pages/Cms/RekeningBank/paginate.vue"),
      },
    ],
  },
  {
    path: "/Master-Sistem",
    component: Cms,
    meta: { requiresAuth: true },
    children: [
      {
        path: "Roles",
        name: "MasterSystemAccessLevelPage",
        component: () =>
          import("@/views/pages/Cms/master_system/roles/paginate.vue"),
      },
    ],
  },
  {
    path: "/Transaksi",
    component: Cms,
    meta: { requiresAuth: true },
    children: [
      {
        path: "Kegiatan-Belajar-Mengajar",
        name: "KegiatanBelajarMengajar",
        component: () =>
          import("@/views/pages/Cms/KegiatanBelajarMengajar/paginate.vue"),
      },
      {
        path: "Ujian",
        name: "Ujian",
        component: () => import("@/views/pages/Cms/Ujian/paginate.vue"),
      },
      {
        path: "Infaq",
        name: "Infaq",
        component: () => import("@/views/pages/Cms/Infaq/paginate.vue"),
      },
      {
        path: "Iuran",
        name: "Iuran",
        component: () => import("@/views/pages/Cms/Iuran/paginate.vue"),
      },
    ],
  },
  {
    path: "/Iuran",
    component: Cms,
    meta: { requiresAuth: true },
    children: [
      {
        path: "DataIuran",
        name: "DataIuranPage",
        component: () => import("@/views/pages/Cms/Iuran/paginate.vue"),
      },
      {
        path: "Mutasi",
        name: "MutasiPage",
        component: () => import("@/views/pages/Cms/Iuran/Mutasi.vue"),
      },
      {
        path: "DataSaya",
        name: "SayaPage",
        component: () => import("@/views/pages/Cms/Iuran/Saya.vue"),
      },
    ],
  },
  {
    path: "/Laporan",
    component: Cms,
    meta: { requiresAuth: true },
    children: [
      {
        path: "Evaluasi-Target",
        name: "EvaluasiTarget",
        component: () =>
          import("@/views/pages/Cms/EvaluasiTarget/paginate.vue"),
      },
      {
        path: "Rekap-Absensi-Santri",
        name: "RekapAbsensiSantri",
        component: () =>
          import("@/views/pages/Cms/RekapAbsensiSantri/paginate.vue"),
      },
      {
        path: "Rekap-Absensi-Guru",
        name: "RekapAbsensiGuru",
        component: () =>
          import("@/views/pages/Cms/RekapAbsensiGuru/paginate.vue"),
      },
      {
        path: "Rekap-Perkembangan-Belajar",
        name: "RekapPerkembanganBelajar",
        component: () =>
          import("@/views/pages/Cms/RekapPerkembanganBelajar/paginate.vue"),
      },
      {
        path: "Rekap-Pembayaran-Iuran",
        name: "RekapPembayaranIuran",
        component: () =>
          import("@/views/pages/Cms/RekapPembayaranInfaq/paginate.vue"),
      },
    ],
  },
  // {
  //   path: "/",
  //   component: Cms,
  //   meta: { requiresAuth: true },
  //   children: [
  //     {
  //       path: "Dashboard",
  //       name: "DashboardPage",
  //       component: () => import("@/views/pages/Cms/HomeView.vue"),
  //     },
  //     {
  //       path: "sispena",
  //       name: "SispenaPage",
  //       component: () => import("@/views/pages/Cms/sispena/paginate.vue"),
  //     },
  //     {
  //       path: "finance",
  //       name: "FinancePage",
  //       component: () => import("@/views/pages/Cms/keuangan/paginate.vue"),
  //     },
  //     {
  //       path: "teachers",
  //       name: "TeachersPage",
  //       component: () =>
  //         import("@/views/pages/Cms/TeacherClasses/paginate.vue"),
  //     },

  //     {
  //       path: "task",
  //       name: "TaskPage",
  //       component: () => import("@/views/pages/Cms/tugas/paginate.vue"),
  //     },
  //     {
  //       path: "room",
  //       name: "RoomPage",
  //       component: () => import("@/views/pages/Cms/ruangan/paginate.vue"),
  //     },
  //     {
  //       path: "/kalender-akademik",
  //       name: "EnrollmentTeacherClassPage",
  //       component: () => import("@/views/pages/Cms/kalenderAkademik/Index.vue"),
  //     },
  //   ],
  // },
  // {
  //   path: "/master-system",
  //   component: Cms,
  //   meta: { requiresAuth: true },
  //   children: [
  //     {
  //       path: "access-level",
  //       name: "MasterSystemAccessLevelPage",
  //       component: () =>
  //         import("@/views/pages/Cms/master_system/roles/paginate.vue"),
  //     },
  //     {
  //       path: "menu",
  //       name: "MasterSystemMenuPage",
  //       component: () =>
  //         import("@/views/pages/Cms/master_system/menu/paginate.vue"),
  //     },
  //     {
  //       path: "rules",
  //       name: "MasterSystemRulesPage",
  //       component: () =>
  //         import("@/views/pages/Cms/master_system/rules/paginate.vue"),
  //     },
  //     {
  //       path: "access-menu",
  //       name: "MasterSystemAccessMenuPage",
  //       component: () =>
  //         import("@/views/pages/Cms/master_system/asccess_menus/paginate.vue"),
  //     },
  //   ],
  // },
  // {
  //   path: "/data-master",
  //   component: Cms,
  //   meta: { requiresAuth: true },
  //   children: [
  //     {
  //       path: "classes",
  //       name: "BackofficeClassesPage",
  //       component: () =>
  //         import("@/views/pages/Cms/backoffice/classes/paginate.vue"),
  //     },
  //     {
  //       path: "subjects",
  //       name: "BackofficeSubjectPage",
  //       component: () =>
  //         import("@/views/pages/Cms/backoffice/subjects/paginate.vue"),
  //     },
  //     {
  //       path: "personality",
  //       name: "BackofficePersonalityPage",
  //       component: () =>
  //         import("@/views/pages/Cms/backoffice/personality/paginate.vue"),
  //     },
  //     {
  //       path: "scores",
  //       name: "BackofficeScoresPage",
  //       component: () =>
  //         import("@/views/pages/Cms/backoffice/scores/paginate.vue"),
  //     },
  //     {
  //       path: "aspect",
  //       name: "BackofficeAspectPage",
  //       component: () =>
  //         import("@/views/pages/Cms/backoffice/aspect/paginate.vue"),
  //     },
  //     {
  //       path: "fee-type",
  //       name: "BackofficeFeeTypePage",
  //       component: () =>
  //         import("@/views/pages/Cms/backoffice/fee_type/paginate.vue"),
  //     },
  //     {
  //       path: "fee",
  //       name: "BackofficeFeePage",
  //       component: () =>
  //         import("@/views/pages/Cms/backoffice/fee/paginate.vue"),
  //     },
  //     {
  //       path: "expense-type",
  //       name: "BackofficeExpenseTypePage",
  //       component: () =>
  //         import("@/views/pages/Cms/backoffice/expense_type/paginate.vue"),
  //     },
  //     {
  //       path: "form-questions",
  //       name: "BackofficeFormQuestionsPage",
  //       component: () =>
  //         import("@/views/pages/Cms/backoffice/questions/paginate.vue"),
  //     },
  //     {
  //       path: "form-question",
  //       name: "QuestionsDetail",
  //       component: () =>
  //         import("@/views/pages/Cms/backoffice/questions/detail.vue"),
  //     },
  //     {
  //       path: "teachers",
  //       name: "UserTeachersPage",
  //       component: () => import("@/views/pages/Cms/users/guru/paginate.vue"),
  //     },
  //     {
  //       path: "staff",
  //       name: "StaffPage",
  //       component: () => import("@/views/pages/Cms/users/staff/paginate.vue"),
  //     },
  //     {
  //       path: "student",
  //       name: "StudentPage",
  //       component: () =>
  //         import("@/views/pages/Cms/students/siswa/paginate.vue"),
  //     },
  //     {
  //       path: "program",
  //       name: "ProgramsPage",
  //       component: () => import("@/views/pages/Cms/programs/paginate.vue"),
  //     },
  //   ],
  // },
  // {
  //   path: "/finance",
  //   component: Cms,
  //   meta: { requiresAuth: true },
  //   children: [
  //     {
  //       path: "payment",
  //       name: "PaymentPage",
  //       component: () =>
  //         import("@/views/pages/Cms/finance/payment/paginate.vue"),
  //     },
  //     {
  //       path: "expense",
  //       name: "PaymentExpensePage",
  //       component: () =>
  //         import("@/views/pages/Cms/finance/expense/paginate.vue"),
  //     },
  //     {
  //       path: "transactions",
  //       name: "TransactionsPage",
  //       component: () =>
  //         import("@/views/pages/Cms/finance/transactions/paginate.vue"),
  //     },
  //   ],
  // },
  // {
  //   path: "/users",
  //   component: Cms,
  //   meta: { requiresAuth: true },
  //   children: [
  //     {
  //       path: "teachers",
  //       name: "UserTeachersPage",
  //       component: () => import("@/views/pages/Cms/users/guru/paginate.vue"),
  //     },
  //     {
  //       path: "staff",
  //       name: "StaffPage",
  //       component: () => import("@/views/pages/Cms/users/staff/paginate.vue"),
  //     },
  //     {
  //       path: "student",
  //       name: "StudentPage",
  //       component: () =>
  //         import("@/views/pages/Cms/students/siswa/paginate.vue"),
  //     },
  //     {
  //       path: "users",
  //       name: "UsersUserPage",
  //       component: () =>
  //         import("@/views/pages/Cms/backoffice/users/paginate.vue"),
  //     },
  //   ],
  // },
  // {
  //   path: "/sispena",
  //   component: Cms,
  //   meta: { requiresAuth: true },
  //   children: [
  //     {
  //       path: "development",
  //       name: "SispenaDevelopmentPage",
  //       component: () =>
  //         import("@/views/pages/Cms/sispena/development/paginate.vue"),
  //     },
  //   ],
  // },
  // {
  //   path: "/informations",
  //   component: Cms,
  //   meta: { requiresAuth: true },
  //   children: [
  //     {
  //       path: "child-development",
  //       name: "ChildDevelopmentPage",
  //       component: () =>
  //         import(
  //           "@/views/pages/Cms/informations/ChildDevelopment/paginate.vue"
  //         ),
  //     },
  //   ],
  // },
  // {
  //   path: "/students",
  //   component: Cms,
  //   meta: { requiresAuth: true },
  //   children: [
  //     {
  //       path: "register",
  //       name: "RegisterPage",
  //       component: () =>
  //         import("@/views/pages/Cms/students/register/paginate.vue"),
  //     },

  //     {
  //       path: "development",
  //       name: "StudentsDevelopmentPage",
  //       component: () =>
  //         import("@/views/pages/Cms/students/development/paginate.vue"),
  //     },

  //     {
  //       path: "my-student",
  //       name: "MyStudentPage",
  //       component: () => import("@/views/pages/Cms/murid/paginate.vue"),
  //     },
  //   ],
  // },
  // {
  //   path: "/attendances",
  //   component: Cms,
  //   meta: { requiresAuth: true },
  //   children: [
  //     {
  //       path: "students",
  //       name: "AttendancesStudentsPage",
  //       component: () =>
  //         import("@/views/pages/Cms/attendances/students/paginate.vue"),
  //     },
  //     {
  //       path: "teachers",
  //       name: "AttendancesTeachersPage",
  //       component: () =>
  //         import("@/views/pages/Cms/attendances/teachers/paginate.vue"),
  //     },
  //     {
  //       path: "reports",
  //       name: "AttendancesReportsPage",
  //       component: () =>
  //         import("@/views/pages/Cms/attendances/reports/paginate.vue"),
  //     },
  //   ],
  // },
  // {
  //   path: "/enrollments",
  //   component: Cms,
  //   meta: { requiresAuth: true },
  //   children: [
  //     {
  //       path: "student-class",
  //       name: "EnrollmentStudentClassPage",
  //       component: () =>
  //         import("@/views/pages/Cms/enrollments/student-classes/paginate.vue"),
  //     },
  //     {
  //       path: "teacher-class",
  //       name: "EnrollmentTeacherClassPage",
  //       component: () =>
  //         import("@/views/pages/Cms/enrollments/teacher-classes/paginate.vue"),
  //     },
  //   ],
  // },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// router.beforeEach((to, from, next) => {
//   if (to.matched.some((record) => record.meta.requiresAuth)) {
//     next();
//   } else {
//     if (store.getters["auth/isAuthenticated"]) {
//       next("/dashboard");
//     } else {
//       store.dispatch("auth/LogOut");
//     }
//   }
// });

export default router;
